const REACT_CONTENT_TYPES = [
  'application/vnd.aha.react',
  'application/vnd.aha.react_entrypoint',
];

export function allowReactContentPreview(
  toolCall: any,
  artifact: any
): boolean {
  const isReactContent = REACT_CONTENT_TYPES.includes(artifact?.contentType);
  const isNotPreparing = toolCall?.status !== 'preparing';
  const allowsScriptableArtifacts =
    window.currentAccount?.aiAllowScriptableArtifacts || false;

  return allowsScriptableArtifacts && (!isReactContent || isNotPreparing);
}
